import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Col, Label } from 'react-bootstrap';
import { injectIntl, FormattedNumber } from 'react-intl';
import IntlDateRelative from 'components/layout/IntlDateRelative';

import { getPriceNegotiationLabels } from 'helpers/priceNegotiation';

class DashboardCustomer extends React.Component {
  gotoPriceNegotiation = priceNegotiationId => {
    const { appIntl, history } = this.props;
    history.push(appIntl.urlPrefix + `account/priceNegotiations/${priceNegotiationId}`);
  };

  getTextClass = priceNegotiation => {
    if (priceNegotiation.current_offer_for === 'target') {
      return 'text-success';
    }

    return '';
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      list,
    } = this.props;

    if (list.data.count > 4) {
      return (
        <Col xs={12} md={6} className="m-t-20 grid-item">
          <div className="widget-11 card no-margin b-grey b-a">
            <div className="card-header p-t-20 p-l-15">
              <div className="card-title">{messages.price_negotiations}</div>
            </div>
            <div>
              <table className="table table-condensed table-hover">
                <tbody>
                  {list.data.list.map((priceNegotiation, i) => {
                    return i < 5 ? (
                      <tr key={priceNegotiation.id} onClick={() => this.gotoPriceNegotiation(priceNegotiation.id)}>
                        <td className="font-secondary all-caps fs-12">{priceNegotiation.item_name}</td>
                        <td className="text-right">
                          <span className="hint-text small">
                            {getPriceNegotiationLabels(priceNegotiation, messages)}
                          </span>
                        </td>
                        <td>
                          <span className={'font-secondary fs-18 ' + this.getTextClass(priceNegotiation)}>
                            <FormattedNumber
                              value={priceNegotiation.current_offer}
                              style="currency"
                              currency={priceNegotiation.currency}
                            />
                          </span>
                        </td>
                      </tr>
                    ) : null;
                  })}
                </tbody>
              </table>
            </div>
            <div className="p-b-20">
              <p className="no-margin text-center">
                <Link to={appIntl.urlPrefix + 'account/priceNegotiations'} className="text-master">
                  {messages.view_all}
                </Link>
              </p>
            </div>
          </div>
        </Col>
      );
    }

    if (list.data.count > 0) {
      return list.data.list.map(priceNegotiation => {
        const priceNegotiationDetailsUrl = appIntl.urlPrefix + `account/priceNegotiations/${priceNegotiation.id}`;

        return (
          <Col xs={12} md={6} lg={3} key={priceNegotiation.id} className="m-t-20 grid-item">
            <div className="widget-11 card no-margin b-grey b-a">
              <div className="card-header p-t-20 p-l-15">
                <div className="card-title">{messages.price_negotiation}</div>
              </div>
              <div className="card-description p-l-15 p-r-15 p-b-10">
                <div>
                  {priceNegotiation.item_name}{' '}
                  <span className={this.getTextClass(priceNegotiation)}>
                    <FormattedNumber
                      value={priceNegotiation.current_offer}
                      style="currency"
                      currency={priceNegotiation.currency}
                    />
                  </span>
                </div>
                <div>{getPriceNegotiationLabels(priceNegotiation, messages)}</div>
              </div>
              <div className="card-content bg-master-lighter p-t-35 p-b-35 text-center">
                <Link to={priceNegotiationDetailsUrl}>
                  <i className="fal fa-comments-alt-dollar fa-4x" />
                </Link>
              </div>
              <div className="card-footer clearfix">
                <div className="time">
                  <IntlDateRelative date={priceNegotiation.cdate} />
                </div>
                <ul className="reactions">
                  <li>
                    <Link to={priceNegotiationDetailsUrl}>
                      {messages.view} <i className="fad fa-arrow-circle-right" />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        );
      });
    }

    return null;
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    ordersList: state.list.orders,
    priceNegotiationsList: state.list.priceNegotiations,
    projectConfig: state.data.projectConfig,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(DashboardCustomer)));
